import React from "react";

export const theme = {
  mainDark: "#231942",
  secondDark: "#5E548E",
  mainViolet: "#9F86C0",
  secondViolet: "#BE95C4",
  mainPink: "#E0B1CB"
};

export const ColorContext = React.createContext();

export function useTheme() {
  const ctx = React.useContext(ColorContext);

  return ctx;
}
